export default __webpack_public_path__ + "static/rpa-hero-robot-df1a25327fd68e6c28b47f31aa0d18bc.png";